export default function selectorError(message) {
  var fetched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    error: true,
    fetched: fetched,
    message: message
  };
}